import { QueryErrorBoundary } from '@components/errors/QueryErrorBoundary'
import { StudentAttendancePunctualityTab } from '@features/student-page/components/StudentAttendancePunctualityTab'
import { createFileRoute } from '@tanstack/react-router'
import { LoadingIndicator } from '@ui/LoadingIndicator'
import { Suspense } from 'react'

export const Route = createFileRoute('/_layout/students/$studentNo/attendance/punctuality')({
    component: RouteComponent,
    staticData: {
        crumb: {
            label: 'Punctuality',
        },
    },
})

function RouteComponent() {
    const { studentNo } = Route.useParams()

    return (
        <QueryErrorBoundary title="Failed to load student punctuality">
            <Suspense fallback={<LoadingIndicator resource="punctuality" />}>
                <StudentAttendancePunctualityTab studentNo={studentNo} />
            </Suspense>
        </QueryErrorBoundary>
    )
}
